import { PlanPurchaseExperienceSummaryLineProps } from './PlanPurchaseExperienceSummaryLine'
import { ReactNode } from 'react'
import { Typography } from '@dtx-company/design-system/src'

interface PlanPurchaseExperienceSummaryLineLabelProps {
  appearance: PlanPurchaseExperienceSummaryLineProps['appearance']
  children?: ReactNode
}

export function PlanPurchaseExperienceSummaryLineLabel(
  props: PlanPurchaseExperienceSummaryLineLabelProps
): JSX.Element {
  return (
    <Typography
      variant="bodyMedium"
      color={props.appearance === 'primary' ? 'primary.main' : 'text.secondary'}
    >
      {props.children}
    </Typography>
  )
}
